import React, { useCallback, useEffect, useState } from "react";
import "./supplierconfig.css";
import { PCB_CORE_URL } from "../../config";
import { useStore } from "../../store";

const API_BASE = (PCB_CORE_URL || "").replace(/\/+$/, "");
const API_CONFIG = `${API_BASE}/superuser/config/`;

const MAX_QTY = "18446744073709551615";
const MAX_DURATION_DAYS = "2147483647";

const ASSEMBLY_TIER_CONFIGS = [
  {
    key: "assembly_duration_coeff_tiers",
    title: "Urgence / délai",
    quantityLabel: "Jours",
    priceLabel: "Coeff.",
    quantityField: "duration_days",
    priceField: "coeff",
    defaults: [
      { duration_days: 0, coeff: 0 },
      { duration_days: 1, coeff: 10.1 },
      { duration_days: 2, coeff: 9.2 },
      { duration_days: 3, coeff: 8.3 },
      { duration_days: 4, coeff: 7.3 },
      { duration_days: 5, coeff: 6.3 },
      { duration_days: 6, coeff: 5.3 },
      { duration_days: 7, coeff: 4.3 },
      { duration_days: 8, coeff: 3.3 },
      { duration_days: 9, coeff: 2.5 },
      { duration_days: 10, coeff: 2.1 },
      { duration_days: 11, coeff: 1.95 },
      { duration_days: 12, coeff: 1.85 },
      { duration_days: 13, coeff: 1.8 },
      { duration_days: 14, coeff: 1.78 },
      { duration_days: 15, coeff: 1.76 },
      { duration_days: 16, coeff: 1.74 },
      { duration_days: 17, coeff: 1.72 },
      { duration_days: 18, coeff: 1.7 },
      { duration_days: 19, coeff: 1.69 },
      { duration_days: 20, coeff: 1.68 },
      { duration_days: 21, coeff: 1.67 },
      { duration_days: 22, coeff: 1.66 },
      { duration_days: 23, coeff: 1.65 },
      { duration_days: 24, coeff: 1.64 },
      { duration_days: 25, coeff: 1.63 },
      { duration_days: MAX_DURATION_DAYS, coeff: 1.62 },
    ],
  },
  {
    key: "assembly_cms_price_tiers",
    title: "CMS",
    defaults: [
      { quantity: 0, price: 0 },
      { quantity: 1, price: 1.53 },
      { quantity: 10, price: 1.02 },
      { quantity: 50, price: 0.255 },
      { quantity: 200, price: 0.1475 },
      { quantity: 500, price: 0.102 },
      { quantity: 999, price: 0.0765 },
      { quantity: MAX_QTY, price: 0.051 },
    ],
  },
  {
    key: "assembly_tht_price_tiers",
    title: "Traversant",
    defaults: [
      { quantity: 0, price: 0 },
      { quantity: 1, price: 3.06 },
      { quantity: 10, price: 2.1216 },
      { quantity: 50, price: 2.55 },
      { quantity: 200, price: 2.04 },
      { quantity: 500, price: 1.938 },
      { quantity: 999, price: 1.836 },
      { quantity: MAX_QTY, price: 3.06 },
    ],
  },
  {
    key: "assembly_pressfit_price_tiers",
    title: "Press-fit",
    defaults: [
      { quantity: 0, price: 0 },
      { quantity: 1, price: 20.4 },
      { quantity: 5, price: 15.3 },
      { quantity: 10, price: 10.2 },
      { quantity: MAX_QTY, price: 8.16 },
    ],
  },
  {
    key: "assembly_non_monte_price_tiers",
    title: "Non monté",
    defaults: [
      { quantity: 0, price: 0 },
      { quantity: 1, price: 0.1 },
      { quantity: 2, price: 0.1 },
      { quantity: 5, price: 0.1 },
      { quantity: 10, price: 0.1 },
      { quantity: MAX_QTY, price: 0.1 },
    ],
  },
  {
    key: "assembly_lines_price_tiers",
    title: "Lignes BOM",
    defaults: [
      { quantity: 0, price: 0 },
      { quantity: 10, price: 8.16 },
      { quantity: 30, price: 5.1 },
      { quantity: MAX_QTY, price: 2.55 },
    ],
  },
  {
    key: "assembly_packing_price_tiers",
    title: "Packing PCBA",
    defaults: [
      { quantity: 0, price: 0 },
      { quantity: 10, price: 0.816 },
      { quantity: 100, price: 0.51 },
      { quantity: MAX_QTY, price: 0.306 },
    ],
  },
  {
    key: "assembly_depaneling_price_tiers",
    title: "Dépaneling",
    defaults: [
      { quantity: 0, price: 0 },
      { quantity: 10, price: 4.08 },
      { quantity: 50, price: 3.57 },
      { quantity: 100, price: 3.06 },
      { quantity: 200, price: 2.55 },
      { quantity: 500, price: 2.04 },
      { quantity: 1000, price: 1.02 },
      { quantity: MAX_QTY, price: 0.714 },
    ],
  },
  {
    key: "assembly_xray_price_tiers",
    title: "X-ray",
    defaults: [
      { quantity: 0, price: 0 },
      { quantity: 2, price: 10.2 },
      { quantity: 3, price: 10.2 },
      { quantity: 5, price: 10.2 },
      { quantity: 10, price: 10.2 },
      { quantity: 20, price: 10.2 },
      { quantity: 30, price: 10.2 },
      { quantity: 40, price: 10.2 },
      { quantity: 50, price: 10.2 },
      { quantity: MAX_QTY, price: 10.2 },
    ],
  },
];

const TIER_FIELDS = ASSEMBLY_TIER_CONFIGS.map((cfg) => cfg.key);

const INITIAL_FORM = {
  hourly_cost: "0",
  pcb_margin_pct: "0",
  assembly_margin_pct: "0",
  components_margin_pct: "0",
  fixed_fee: "0",
  shipping_default: "0",
  default_discount_kind: "none",
  default_discount_value: "0",
  components_purchase_extra_pct: "2.00",
  components_purchase_price_threshold: "3.00",
  components_purchase_min_qty: "15",
  components_purchase_max_qty: "60",
  assembly_cms_unit_price: "",
  assembly_tht_unit_price: "",
  assembly_pressfit_unit_price: "",
  assembly_non_monte_unit_price: "",
  assembly_xray_unit_price: "",
  assembly_lines_unit_price: "",
  assembly_packing_unit_price: "",
  assembly_depaneling_unit_price: "",
  assembly_cms_fixed_fee: "",
  assembly_tht_fixed_fee: "",
  assembly_pressfit_fixed_fee: "",
  assembly_non_monte_fixed_fee: "",
  assembly_lines_fixed_fee: "",
  assembly_packing_fixed_fee: "",
  assembly_depaneling_fixed_fee: "",
  assembly_apply_urgency_to_placements: true,
  assembly_apply_urgency_to_fixed_fees: false,
  assembly_apply_urgency_to_lines: false,
  assembly_apply_urgency_to_packing: false,
  assembly_apply_urgency_to_depaneling: false,
  assembly_apply_urgency_to_xray: false,
  ...Object.fromEntries(TIER_FIELDS.map((key) => [key, []])),
};

const DECIMAL_FIELDS = [
  "hourly_cost",
  "pcb_margin_pct",
  "assembly_margin_pct",
  "components_margin_pct",
  "fixed_fee",
  "shipping_default",
  "default_discount_value",
  "components_purchase_extra_pct",
  "components_purchase_price_threshold",
  "assembly_cms_unit_price",
  "assembly_tht_unit_price",
  "assembly_pressfit_unit_price",
  "assembly_non_monte_unit_price",
  "assembly_xray_unit_price",
  "assembly_lines_unit_price",
  "assembly_packing_unit_price",
  "assembly_depaneling_unit_price",
  "assembly_cms_fixed_fee",
  "assembly_tht_fixed_fee",
  "assembly_pressfit_fixed_fee",
  "assembly_non_monte_fixed_fee",
  "assembly_lines_fixed_fee",
  "assembly_packing_fixed_fee",
  "assembly_depaneling_fixed_fee",
];

function stringifyMaybe(value, fallback = "") {
  if (value === null || value === undefined) return fallback;
  return String(value);
}

function stringifyTierRows(rows, config) {
  const qField = config.quantityField || "quantity";
  const pField = config.priceField || "price";
  const source = Array.isArray(rows) && rows.length ? rows : config.defaults;
  return source.map((row) => ({
    [qField]: stringifyMaybe(row?.[qField], ""),
    [pField]: stringifyMaybe(row?.[pField], ""),
  }));
}

function parseTierRows(rows, config) {
  const qField = config.quantityField || "quantity";
  const pField = config.priceField || "price";
  return (Array.isArray(rows) ? rows : [])
    .map((row) => {
      const quantityRaw = String(row?.[qField] ?? "").trim();
      const priceRaw = String(row?.[pField] ?? "").trim();
      if (!quantityRaw && !priceRaw) return null;
      return {
        [qField]: quantityRaw === "" ? 0 : Number.parseInt(quantityRaw, 10),
        [pField]: priceRaw === "" ? 0 : Number(priceRaw),
      };
    })
    .filter((row) => row && Number.isFinite(row[qField]) && Number.isFinite(row[pField]))
    .sort((a, b) => Number(a[qField] || 0) - Number(b[qField] || 0));
}

function buildForm(data) {
  const tierValues = Object.fromEntries(
    ASSEMBLY_TIER_CONFIGS.map((config) => [
      config.key,
      stringifyTierRows(data?.[config.key], config),
    ])
  );

  return {
    ...INITIAL_FORM,
    ...tierValues,
    hourly_cost: stringifyMaybe(data?.hourly_cost, "0"),
    pcb_margin_pct: stringifyMaybe(data?.pcb_margin_pct, "0"),
    assembly_margin_pct: stringifyMaybe(data?.assembly_margin_pct, "0"),
    components_margin_pct: stringifyMaybe(data?.components_margin_pct, "0"),
    fixed_fee: stringifyMaybe(data?.fixed_fee, "0"),
    shipping_default: stringifyMaybe(data?.shipping_default, "0"),
    default_discount_kind: stringifyMaybe(data?.default_discount_kind, "none"),
    default_discount_value: stringifyMaybe(data?.default_discount_value, "0"),
    components_purchase_extra_pct: stringifyMaybe(data?.components_purchase_extra_pct, "2.00"),
    components_purchase_price_threshold: stringifyMaybe(data?.components_purchase_price_threshold, "3.00"),
    components_purchase_min_qty: stringifyMaybe(data?.components_purchase_min_qty, "15"),
    components_purchase_max_qty: stringifyMaybe(data?.components_purchase_max_qty, "60"),
    assembly_cms_unit_price: stringifyMaybe(data?.assembly_cms_unit_price),
    assembly_tht_unit_price: stringifyMaybe(data?.assembly_tht_unit_price),
    assembly_pressfit_unit_price: stringifyMaybe(data?.assembly_pressfit_unit_price),
    assembly_non_monte_unit_price: stringifyMaybe(data?.assembly_non_monte_unit_price),
    assembly_xray_unit_price: stringifyMaybe(data?.assembly_xray_unit_price),
    assembly_lines_unit_price: stringifyMaybe(data?.assembly_lines_unit_price),
    assembly_packing_unit_price: stringifyMaybe(data?.assembly_packing_unit_price),
    assembly_depaneling_unit_price: stringifyMaybe(data?.assembly_depaneling_unit_price),
    assembly_cms_fixed_fee: stringifyMaybe(data?.assembly_cms_fixed_fee),
    assembly_tht_fixed_fee: stringifyMaybe(data?.assembly_tht_fixed_fee),
    assembly_pressfit_fixed_fee: stringifyMaybe(data?.assembly_pressfit_fixed_fee),
    assembly_non_monte_fixed_fee: stringifyMaybe(data?.assembly_non_monte_fixed_fee),
    assembly_lines_fixed_fee: stringifyMaybe(data?.assembly_lines_fixed_fee),
    assembly_packing_fixed_fee: stringifyMaybe(data?.assembly_packing_fixed_fee),
    assembly_depaneling_fixed_fee: stringifyMaybe(data?.assembly_depaneling_fixed_fee),
    assembly_apply_urgency_to_placements: Boolean(data?.assembly_apply_urgency_to_placements ?? true),
    assembly_apply_urgency_to_fixed_fees: Boolean(data?.assembly_apply_urgency_to_fixed_fees ?? false),
    assembly_apply_urgency_to_lines: Boolean(data?.assembly_apply_urgency_to_lines ?? false),
    assembly_apply_urgency_to_packing: Boolean(data?.assembly_apply_urgency_to_packing ?? false),
    assembly_apply_urgency_to_depaneling: Boolean(data?.assembly_apply_urgency_to_depaneling ?? false),
    assembly_apply_urgency_to_xray: Boolean(data?.assembly_apply_urgency_to_xray ?? false),
  };
}

function toPayload(form) {
  const payload = {
    default_discount_kind: form.default_discount_kind || "none",
    assembly_apply_urgency_to_placements: !!form.assembly_apply_urgency_to_placements,
    assembly_apply_urgency_to_fixed_fees: !!form.assembly_apply_urgency_to_fixed_fees,
    assembly_apply_urgency_to_lines: !!form.assembly_apply_urgency_to_lines,
    assembly_apply_urgency_to_packing: !!form.assembly_apply_urgency_to_packing,
    assembly_apply_urgency_to_depaneling: !!form.assembly_apply_urgency_to_depaneling,
    assembly_apply_urgency_to_xray: !!form.assembly_apply_urgency_to_xray,
  };

  for (const key of DECIMAL_FIELDS) {
    const raw = String(form[key] ?? "").trim();
    payload[key] = raw === "" ? null : Number(raw);
  }

  for (const key of ["components_purchase_min_qty", "components_purchase_max_qty"]) {
    const raw = String(form[key] ?? "").trim();
    payload[key] = raw === "" ? null : Number.parseInt(raw, 10);
  }

  for (const config of ASSEMBLY_TIER_CONFIGS) {
    payload[config.key] = parseTierRows(form[config.key], config);
  }

  return payload;
}

function ToggleField({ label, checked, onChange }) {
  return (
    <label className="boLabel" style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <span>{label}</span>
    </label>
  );
}

function TierTable({ config, rows, onChange }) {
  const qField = config.quantityField || "quantity";
  const pField = config.priceField || "price";
  const quantityLabel = config.quantityLabel || "Quantité min.";
  const priceLabel = config.priceLabel || "Prix unitaire";

  function updateRow(index, field, value) {
    onChange(rows.map((row, idx) => (idx === index ? { ...row, [field]: value } : row)));
  }

  function addRow() {
    onChange([...(rows || []), { [qField]: "", [pField]: "" }]);
  }

  function removeRow(index) {
    onChange((rows || []).filter((_, idx) => idx !== index));
  }

  function resetDefaults() {
    onChange(stringifyTierRows(config.defaults, config));
  }

  return (
    <div className="boTierBlock">
      <div className="boTierHeader">
        <div className="boTierTitle">{config.title}</div>
        <div className="boTierActions">
          <button type="button" className="boBtn boBtnSmall" onClick={addRow}>Ajouter</button>
          <button type="button" className="boBtn boBtnSmall" onClick={resetDefaults}>Défaut</button>
        </div>
      </div>
      <div className="boTierGrid boTierGridHead">
        <div>{quantityLabel}</div>
        <div>{priceLabel}</div>
        <div />
      </div>
      {(rows || []).map((row, index) => (
        <div className="boTierGrid" key={`${config.key}-${index}`}>
          <input
            className="boInput mono"
            value={row?.[qField] ?? ""}
            onChange={(e) => updateRow(index, qField, e.target.value)}
            inputMode="numeric"
          />
          <input
            className="boInput mono"
            value={row?.[pField] ?? ""}
            onChange={(e) => updateRow(index, pField, e.target.value)}
            inputMode="decimal"
          />
          <button type="button" className="boBtn boBtnSmall" onClick={() => removeRow(index)}>Suppr.</button>
        </div>
      ))}
    </div>
  );
}

export default function SupplierConfig() {
  const access = useStore((s) => s.user.access);

  const apiFetch = useCallback(
    async (url, options = {}) => {
      return fetch(url, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...(access ? { Authorization: `Bearer ${access}` } : {}),
          ...(options.headers || {}),
        },
      });
    },
    [access]
  );

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const [form, setForm] = useState(INITIAL_FORM);

  useEffect(() => {
    let alive = true;

    async function load() {
      setLoading(true);
      setErr("");
      try {
        const res = await apiFetch(API_CONFIG, { method: "GET" });
        if (!res.ok) {
          const t = await res.text().catch(() => "");
          throw new Error(`HTTP ${res.status} ${t}`.trim());
        }
        const data = await res.json();
        if (!alive) return;
        setForm(buildForm(data));
      } catch (e) {
        if (!alive) return;
        setErr(e?.message || "Erreur de chargement de la configuration.");
      } finally {
        if (alive) setLoading(false);
      }
    }

    load();
    return () => {
      alive = false;
    };
  }, [apiFetch]);

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function onSave() {
    setSaving(true);
    setErr("");
    setOk("");

    try {
      const res = await apiFetch(API_CONFIG, {
        method: "PUT",
        body: JSON.stringify(toPayload(form)),
      });
      if (!res.ok) {
        const t = await res.text().catch(() => "");
        throw new Error(`HTTP ${res.status} ${t}`.trim());
      }
      const data = await res.json();
      setForm(buildForm(data));
      setOk("Configuration commerciale et assembly enregistrée. Les prochains devis utiliseront automatiquement ces réglages.");
    } catch (e) {
      setErr(e?.message || "Erreur de sauvegarde.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="boSup">
      <div className="boSupHeader">
        <div>
          <h1 className="boSupTitle">Configuration commerciale</h1>
          {/* <div className="boSupSub">Pilotez les marges, remises et regles de calcul assembly appliquees automatiquement aux futurs devis.</div> */}
        </div>
      </div>

      {err ? (
        <div className="boCard boError">
          <div className="boErrorTitle">Erreur</div>
          <div className="boErrorText">{err}</div>
        </div>
      ) : null}

      {ok ? (
        <div className="boCard" style={{ marginBottom: 12, borderColor: "rgba(34,197,94,0.28)", background: "rgba(34,197,94,0.08)" }}>
          <div className="boErrorTitle" style={{ color: "#bbf7d0" }}>Sauvegarde ok</div>
          <div className="boErrorText">{ok}</div>
        </div>
      ) : null}

      <div className="boSupGrid">
        <div className="boCard">
          <div className="boSectionTitle">Règles globales</div>

          {loading ? (
            <>
              <div className="boSkeletonRow" />
              <div className="boSkeletonRow" />
              <div className="boSkeletonRow" />
            </>
          ) : (
            <div className="boFormGrid">
              <label className="boLabel">
                Coût horaire
                <input className="boInput mono" value={form.hourly_cost} onChange={(e) => updateField("hourly_cost", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Marge PCB (%)
                <input className="boInput mono" value={form.pcb_margin_pct} onChange={(e) => updateField("pcb_margin_pct", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Marge assemblage (%)
                <input className="boInput mono" value={form.assembly_margin_pct} onChange={(e) => updateField("assembly_margin_pct", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Marge composants (%)
                <input className="boInput mono" value={form.components_margin_pct} onChange={(e) => updateField("components_margin_pct", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Frais fixes par devis
                <input className="boInput mono" value={form.fixed_fee} onChange={(e) => updateField("fixed_fee", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Shipping par défaut
                <input className="boInput mono" value={form.shipping_default} onChange={(e) => updateField("shipping_default", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Remise future par défaut
                <select className="boInput" value={form.default_discount_kind} onChange={(e) => updateField("default_discount_kind", e.target.value)}>
                  <option value="none">Aucune</option>
                  <option value="pct">Pourcentage</option>
                  <option value="amount">Montant</option>
                </select>
              </label>
              <label className="boLabel">
                Valeur de la remise
                <input className="boInput mono" value={form.default_discount_value} onChange={(e) => updateField("default_discount_value", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Seuil prix unitaire composants (?)
                <input className="boInput mono" value={form.components_purchase_price_threshold} onChange={(e) => updateField("components_purchase_price_threshold", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Majoration composants bon marché (%)
                <input className="boInput mono" value={form.components_purchase_extra_pct} onChange={(e) => updateField("components_purchase_extra_pct", e.target.value)} inputMode="decimal" />
              </label>
              <label className="boLabel">
                Quantité mini à commander
                <input className="boInput mono" value={form.components_purchase_min_qty} onChange={(e) => updateField("components_purchase_min_qty", e.target.value)} inputMode="numeric" />
              </label>
              <label className="boLabel">
                Quantité maxi à commander
                <input className="boInput mono" value={form.components_purchase_max_qty} onChange={(e) => updateField("components_purchase_max_qty", e.target.value)} inputMode="numeric" />
              </label>
            </div>
          )}
        </div>

        <div className="boCard">
          <div className="boSectionTitle">Interface assembly</div>
          {loading ? (
            <>
              <div className="boSkeletonRow" />
              <div className="boSkeletonRow" />
              <div className="boSkeletonRow" />
            </>
          ) : (
            <>
              <div className="boSupSub" style={{ marginBottom: 14 }}>
                Laissez un champ vide pour conserver la valeur standard du configuration assembly. Remplissez-le pour forcer une nouvelle valeur sur les prochains devis.
              </div>

              <div className="boSectionTitle" style={{ fontSize: 13, marginBottom: 10 }}>Prix unitaires</div>
              <div className="boFormGrid">
                <label className="boLabel">CMS unitaire<input className="boInput mono" value={form.assembly_cms_unit_price} onChange={(e) => updateField("assembly_cms_unit_price", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Traversant unitaire<input className="boInput mono" value={form.assembly_tht_unit_price} onChange={(e) => updateField("assembly_tht_unit_price", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Press-fit unitaire<input className="boInput mono" value={form.assembly_pressfit_unit_price} onChange={(e) => updateField("assembly_pressfit_unit_price", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Non monté unitaire<input className="boInput mono" value={form.assembly_non_monte_unit_price} onChange={(e) => updateField("assembly_non_monte_unit_price", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">X-ray unitaire<input className="boInput mono" value={form.assembly_xray_unit_price} onChange={(e) => updateField("assembly_xray_unit_price", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Lignes unitaire<input className="boInput mono" value={form.assembly_lines_unit_price} onChange={(e) => updateField("assembly_lines_unit_price", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Packing unitaire<input className="boInput mono" value={form.assembly_packing_unit_price} onChange={(e) => updateField("assembly_packing_unit_price", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Dépaneling unitaire<input className="boInput mono" value={form.assembly_depaneling_unit_price} onChange={(e) => updateField("assembly_depaneling_unit_price", e.target.value)} inputMode="decimal" /></label>
              </div>

              <div className="boSectionTitle" style={{ fontSize: 13, margin: "18px 0 10px" }}>Tranches de chiffrage</div>
              {/* <div className="boSupSub" style={{ marginBottom: 12 }}>
                Ces tables permettent de faire baisser le prix unitaire selon le volume. Elles prennent le dessus sur les champs unitaires ci-dessus.
              </div> */}
              <div className="boTierList">
                {ASSEMBLY_TIER_CONFIGS.map((config) => (
                  <TierTable
                    key={config.key}
                    config={config}
                    rows={form[config.key]}
                    onChange={(rows) => updateField(config.key, rows)}
                  />
                ))}
              </div>

              <div className="boSectionTitle" style={{ fontSize: 13, margin: "18px 0 10px" }}>Frais fixes</div>
              <div className="boFormGrid">
                <label className="boLabel">CMS fixe<input className="boInput mono" value={form.assembly_cms_fixed_fee} onChange={(e) => updateField("assembly_cms_fixed_fee", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Traversant fixe<input className="boInput mono" value={form.assembly_tht_fixed_fee} onChange={(e) => updateField("assembly_tht_fixed_fee", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Press-fit fixe<input className="boInput mono" value={form.assembly_pressfit_fixed_fee} onChange={(e) => updateField("assembly_pressfit_fixed_fee", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Non monté fixe<input className="boInput mono" value={form.assembly_non_monte_fixed_fee} onChange={(e) => updateField("assembly_non_monte_fixed_fee", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Lignes fixe<input className="boInput mono" value={form.assembly_lines_fixed_fee} onChange={(e) => updateField("assembly_lines_fixed_fee", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Packing fixe<input className="boInput mono" value={form.assembly_packing_fixed_fee} onChange={(e) => updateField("assembly_packing_fixed_fee", e.target.value)} inputMode="decimal" /></label>
                <label className="boLabel">Dépaneling fixe<input className="boInput mono" value={form.assembly_depaneling_fixed_fee} onChange={(e) => updateField("assembly_depaneling_fixed_fee", e.target.value)} inputMode="decimal" /></label>
              </div>

              <div className="boSectionTitle" style={{ fontSize: 13, margin: "18px 0 10px" }}>Effet urgence</div>
              <div className="boFormGrid">
                <ToggleField label="Appliquer l'urgence aux placements" checked={form.assembly_apply_urgency_to_placements} onChange={(v) => updateField("assembly_apply_urgency_to_placements", v)} />
                <ToggleField label="Appliquer l'urgence aux frais fixes" checked={form.assembly_apply_urgency_to_fixed_fees} onChange={(v) => updateField("assembly_apply_urgency_to_fixed_fees", v)} />
                <ToggleField label="Appliquer l'urgence aux lignes" checked={form.assembly_apply_urgency_to_lines} onChange={(v) => updateField("assembly_apply_urgency_to_lines", v)} />
                <ToggleField label="Appliquer l'urgence au packing" checked={form.assembly_apply_urgency_to_packing} onChange={(v) => updateField("assembly_apply_urgency_to_packing", v)} />
                <ToggleField label="Appliquer l'urgence au dépaneling" checked={form.assembly_apply_urgency_to_depaneling} onChange={(v) => updateField("assembly_apply_urgency_to_depaneling", v)} />
                <ToggleField label="Appliquer l'urgence au X-ray" checked={form.assembly_apply_urgency_to_xray} onChange={(v) => updateField("assembly_apply_urgency_to_xray", v)} />
              </div>
            </>
          )}

          <button className="boBtn boBtnPrimary" onClick={onSave} disabled={saving || loading}>
            {saving ? "Enregistrement..." : "Enregistrer les réglages globaux"}
          </button>
        </div>

        {/* <div className="boCard">
          <div className="boSectionTitle">Impact</div>
          <div className="boList">
            <div className="boListItem">
              <div>
                <div className="boListTitle">Futurs devis</div>
                <div className="boListSub">Les prochaines générations de devis reprennent ces marges, la remise globale, la TVA client et vos overrides assembly.</div>
              </div>
            </div>
            <div className="boListItem">
              <div>
                <div className="boListTitle">Remise entreprise</div>
                <div className="boListSub">Une remise définie sur une entreprise priorise la règle globale. Tous les sous-comptes du master héritent de cette même remise.</div>
              </div>
            </div>
            <div className="boListItem">
              <div>
                <div className="boListTitle">TVA</div>
                <div className="boListSub">La TVA se pilote depuis l'onglet clients / entreprise. Le devis et Pennylane utilisent ensuite cette valeur automatiquement.</div>
              </div>
            </div>
            <div className="boListItem">
              <div>
                <div className="boListTitle">Assembly temps reel</div>
                <div className="boListSub">Vous pouvez corriger les valeurs assembly sans toucher au JSON ni au code, puis laisser le système réutiliser ce calcul sur les commandes suivantes.</div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
